module.exports = __webpack_public_path__ + "img/file-ppt.0230dc7a.svg";